import script from "./InputNumberDefault.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputNumberDefault.vue?vue&type=script&lang=ts&setup=true"

import "./InputNumberDefault.vue?vue&type=style&index=0&id=4070c213&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4070c213"]])

export default __exports__